import { render, staticRenderFns } from "./SettingMemoCategoryModal.vue?vue&type=template&id=21e54503&"
import script from "./SettingMemoCategoryModal.vue?vue&type=script&lang=js&"
export * from "./SettingMemoCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports